import { createSlice } from '@reduxjs/toolkit'
import { LOCAL_STORAGE_STEP } from '../utils/GlobalParams';
import { getLocalStoragKey, setLocalStorage } from './mahutiLocalStorage';


const localStorageCustomerDetails = getLocalStoragKey(LOCAL_STORAGE_STEP, 'customerActivities');
const localStorageSelectedActivities = getLocalStoragKey(LOCAL_STORAGE_STEP, 'selectedActivities')
const localStorageSelectedActivity = getLocalStoragKey(LOCAL_STORAGE_STEP, 'selectedActivity')
const localStorageActivityDate = getLocalStoragKey(LOCAL_STORAGE_STEP, 'activityDate')
const localStorageVisitors = getLocalStoragKey(LOCAL_STORAGE_STEP, 'visitors');
const localStorageCurrentStep = getLocalStoragKey(LOCAL_STORAGE_STEP, 'currentStep')
const localStorageOpportunity = getLocalStoragKey(LOCAL_STORAGE_STEP, 'opportunity')
const localStorageOpportunityProduct = getLocalStoragKey(LOCAL_STORAGE_STEP, 'opportunityProduct')
const localStorageCartDiscountRate = getLocalStoragKey(LOCAL_STORAGE_STEP, 'cartDiscountRate')
const localStorageisNewPayment = getLocalStoragKey(LOCAL_STORAGE_STEP, 'newPayment')
const localStorageSteps = getLocalStoragKey(LOCAL_STORAGE_STEP, 'steps')
const localStorageTimerInterval = getLocalStoragKey(LOCAL_STORAGE_STEP, 'timerInterval')

export const MahutiReducer = createSlice({
    name: 'shoppingCard',
    initialState: {
        currentStep: localStorageCurrentStep ? localStorageCurrentStep : 0,
        flowType: undefined,
        steps: localStorageSteps ? localStorageSteps : [],
        resActivities: [],
        apiIcreditGetURL: undefined,
        paymentCountDown: undefined,
        visitors: localStorageVisitors ? { ...localStorageVisitors } : {
            adults: 1,
            underAge: 1
        },
        lastEditedActivityCampaignId: undefined,
        opportunityProduct: localStorageOpportunityProduct ? localStorageOpportunityProduct : [],
        opportunity: localStorageOpportunity ? localStorageOpportunity : undefined,
        selectedActivity: localStorageSelectedActivity ? localStorageSelectedActivity : undefined,
        activityDate: localStorageActivityDate ? localStorageActivityDate : undefined,
        customerDetails: localStorageCustomerDetails ? localStorageCustomerDetails : {},
        customerFormErrors: {},
        selectedActivities: localStorageSelectedActivities ? localStorageSelectedActivities : [],
        activityEditMode: undefined,
        landingPage: undefined,
        errorMessageStep: undefined,
        isStepFourLoading: undefined,
        columnMessage: {},
        cartTotalSum: 0,
        cartDiscountRate: localStorageCartDiscountRate ? localStorageCartDiscountRate: 0,
        cartDiscountAmount: 0,
        refresh: true,
        allowUpSale: false,
        isInternalMode: false,
        lastOrderId: localStorageOpportunity? localStorageOpportunity.orderId: null,
        newPayment: localStorageisNewPayment? localStorageisNewPayment: false,
        lpName: false,
        timerInterval: localStorageTimerInterval ? localStorageTimerInterval : 5,
        lpParams: {},
        products: undefined,
        countDownChecker: undefined,
        createMode: true
    },
    reducers: {
        resetSelections: (state) => {
            state.currentStep = 0;
            state.visitors = {};
            state.visitors.adults = 1;
            state.visitors.underAge = 1;
            state.selectedActivity = undefined;
            state.activityDate = undefined;
            state.customerDetails = {};
            state.customerFormErrors = {};
            state.activityEditMode = undefined;
            state.paymentCountDown = undefined;
            state.errorMessageStep = undefined;
            state.isStepFourLoading = undefined;
            state.apiIcreditGetURL = undefined;
            state.columnMessage = {};
            state.allowUpSale = false;
            state.newPayment = false;
            state.createMode = true;
            setLocalStorage('step', state)
        },
        setState: (state, action) => {
            const { payload } = action;
            state = payload
        },
        setlpParams: (state, action) => {
            const { payload } = action;
            state.lpParams = payload
            setLocalStorage('step', state);
        },
        setCreateMode: (state, action) => {
            const { payload } = action;
            state.createMode = payload
            setLocalStorage('step', state);
        },
        setProducts: (state, action) => {
            const { payload } = action;
            state.products = payload
            setLocalStorage('step', state);
        },
        setlpName: (state, action) => {
            const { payload } = action;
            state.lpName = payload
        },
        setInteralMode: (state, action) => {
            const { payload } = action;
            state.isInternalMode = payload
        },
        setAllowUpSale: (state, action) => {
            const { payload } = action;
            state.allowUpSale = payload
        },
        setResActivities: (state, action) => {
            const { payload } = action;
            state.resActivities = payload;
        },
        setRefresh: (state, action) => {
            const { payload } = action;
            state.refresh = payload;
        },
        setCartTotalSum: (state, action) => {
            const { payload } = action;
            state.cartTotalSum = payload;
        },
        setCartDiscountRate: (state, action) => {
            const { payload } = action;
            state.cartDiscountRate = payload;
            setLocalStorage('step', state)
        },
        setCartDiscountAmount: (state, action) => {
            const { payload } = action;
            state.cartDiscountAmount = payload;
        },
        setIsStepFourLoading: (state, action) => {
            const {payload} =action;
            state.isStepFourLoading = payload;
        },
        setVisitors: (state, action) => {
            const { payload } = action;

            if (!payload) state.visitors = undefined;
            else {
                if (payload.adults >=0 ) state.visitors.adults = payload.adults;
                if (payload.underAge >=0 ) state.visitors.underAge = payload.underAge;
            }
            setLocalStorage('step', state)
        },
        setSelectedActivity: (state, action) => {
            const { payload } = action;
            state.selectedActivity = payload;
            setLocalStorage('step', state);
        },
        setActivityTiming: (state, action) => {
            const { payload } = action;
            if (state.selectedActivity) {
                if (!state.selectedActivity.timing) {
                    state.selectedActivity.timing = {}
                }
                if (!payload) state.selectedActivity.timing = payload;
                else {
                    state.selectedActivity.timing.id = payload.id;
                    state.selectedActivity.timing.startTime = payload.startTime;
                    state.selectedActivity.timing.endTime = payload.endTime;
                    state.selectedActivity.campaignId = payload.campaignId;
                    state.selectedActivity.productId = payload.productId;

                }
                setLocalStorage('step', state)
            }

        },
        setActivityDate: (state, action) => {
            const { payload } = action;
            state.activityDate = payload;
            setLocalStorage('step', state)

        },
        setCurrentStep: (state, action) => {
            const { payload } = action;
            state.currentStep = payload;
            if(state.steps && state.steps.length > 0) {

                if ((state.steps.length - 1 <= state.currentStep) || state.currentStep === 0) {
                    state.steps[state.currentStep].isCurrent = true
                } else {
                    state.steps[state.currentStep - 1].isCurrent = true
                }

                state.steps.map((item) => {
                    if(item.stepOrder !== state.currentStep){
                        item.isCurrent = false
                    }
                })
            }
            setLocalStorage('step', state);
        },
        setSteps: (state, action) => {
            const { payload } = action;
            state.steps = payload ? payload.map(item => ({...item})) : [];
        },
        updateStep:(state, action) => {
            const { payload } = action;
            const currentStep = payload.currentStep
            if(state.steps) {
                state.steps[currentStep].disabled = payload.disabled
            }
        },
        setApiIcreditGetURL: (state, action) => {
            const { payload } = action;
            state.apiIcreditGetURL = {};
            state.apiIcreditGetURL = payload;
            state.newPayment = true;
            setLocalStorage('step', state);
        },
        setPaymentCountDown: (state, action) => {
            const { payload } = action;
            if(!payload){
                state.paymentCountDown = { status: undefined, timer: undefined };
            }else{
                state.paymentCountDown = payload;
            }
        },
        setCountDownChecker: (state, action) => {
            const { payload } = action;
            state.countDownChecker = payload;
        },
        setCustomerDetails: (state, action) => {
            const newCustomerDetails = action.payload;
            state.customerDetails = { ...newCustomerDetails };
            setLocalStorage('step', state);
        },
        setCustomerFormErrors: (state, action) => {
            const errors = action.payload;
            state.customerFormErrors = { ...errors };
            setLocalStorage('step', state);
        },
        addSelectedActivity: (state, action) => {
            const { payload } = action;
            state.selectedActivities.push(payload);
            setLocalStorage('step', state);

        },
        addOpportunityProduct: (state, action) => {
            const { payload } = action;
            state.opportunityProduct.push(payload);

            setLocalStorage('step', state);
        },
        setOpportunityProduct: (state, action) => {
            const { payload } = action;
            state.opportunityProduct = payload
            setLocalStorage('step', state);
        },
        removeActivity: (state, action) => {
            const activityID = action.payload;
            if (activityID === '*') {state.selectedActivities = []}
            else if (activityID) {
                let index = state.selectedActivities.findIndex(item => {
                    return item.campaignId === activityID.campaignId && item.visitors.adults === activityID.adults && item.visitors.underAge === activityID.underAge
                });
                if(index !== -1){
                    state.selectedActivities.splice(index,1)
                }
            }

            setLocalStorage('step', state);

        },
        setActivityEditMode: (state, action) => {
            const { payload } = action;
            state.activityEditMode = payload;
        },
        setFlowType: (state, action) => {
            const { payload } = action;
            state.flowType = payload;
        },
        setOpportunity: (state, action) => {
            const { payload } = action;

            if (!payload) {
                state.opportunity = undefined;
                state.opportunityProduct = [];
                state.cartTotalSum = 0;
                state.cartDiscountRate = 0;
                state.cartDiscountAmount = 0;
                state.allowUpSale = false;
                state.refresh = false;
            }else{
                const { id, amount, discount, orderId} = payload
                if (!state.opportunity) state.opportunity = {};
                state.opportunity.id = id ? id : state.opportunity.id;
                state.opportunity.amount = amount ? amount : state.opportunity.amount;
                state.opportunity.discount = discount ? discount : state.opportunity.discount;
                state.opportunity.orderId = orderId ? orderId : state.opportunity.orderId;
                state.lastOrderId = orderId ? orderId : state.opportunity.orderId;
                setLocalStorage('step', state);
            }
        },
        setLastOrderId: (state,action) =>{
            const { oid } = action;
            state.lastOrderId = oid ? oid: state.lastOrderId;
        },
        editActivityItem: (state, action) => {
            const { payload } = action;
            const index = state.selectedActivities.findIndex(item => item.campaignId === state.activityEditMode);
            state.selectedActivities[index] = { ...payload }
            state.activityEditMode = undefined;
            // setLocalStorage('step', state);
        },
        updateActivityItem: (state, action) => {
            const newItem = action.payload;
            const productId = newItem.campaignId;
            const index = state.selectedActivities.findIndex(item => item.campaignId === productId);
            state.selectedActivities[index] = { ...newItem }
        },
        setLastEditedActivityCampaignId: (state, action) => {
            const { payload } = action;
            state.lastEditedActivityCampaignId = payload;
        },
        setlandingPage: (state, action) => {
            const { payload } = action;
            state.landingPage = payload;
        },
        setErrorMessageStep: (state, action) => {
            const { payload } = action;
            state.errorMessageStep = payload;
        },
        setColumnMessage: (state, action) => {
            const { payload } = action;
            if(!payload){
                state.columnMessage = {}
            }else{
                state.columnMessage = payload
            }
        }
    }
})

// Action creators are generated for each case reducer function
export const { setState, setOpportunityProduct, setCreateMode, setProducts, setCountDownChecker, setlpParams, setlpName, setCustomerFormErrors, setAllowUpSale, setInteralMode, setlandingPage, setSteps, setIsStepFourLoading, setErrorMessageStep, setColumnMessage, setResActivities, setFlowType,
    resetSelections, editActivityItem, updateActivityItem, addSelectedActivity, setOpportunity, removeActivity, setActivityEditMode,
    setCustomerDetails, setVisitors, setSelectedActivity, setActivityTiming, setActivityDate, setCurrentStep, setApiIcreditGetURL,
    setPaymentCountDown, addOpportunityProduct, setLastEditedActivityCampaignId, setCartTotalSum, setCartDiscountRate, setCartDiscountAmount, setRefresh, setLastOrderId } = MahutiReducer.actions

export default MahutiReducer.reducer